module["exports"] = ["#####", "####", "###", "##", "#"];